<template>
  <div id="app">
    <router-view v-wechat-title='$route.meta.title'></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  data(){
    return {

    }
  }
}
</script>
<style>
.tctab{
    padding: 3vw 2.133vw !important;
    font-size: 25px !important;
}
.van-toast{
  width: 150px;
}
</style>
